

// Events: Terminology iframe => Host
export interface SessionCloseEvent {
  readonly eventName: 'session-close';
  // false if Cancel
  // true if Save and Close
  readonly data: boolean;
}

export interface CodeSelectedEvent {
  readonly eventName: 'code-selected';
}

export interface NoCodeSelectedEvent {
  readonly eventName: 'no-code-selected';
}

export interface SaveFailedEvent {
  readonly eventName: 'save-failed';
}


// Events: Host => Terminology iframe
export interface SaveAndCloseEvent {
  readonly eventName: 'save-and-close';
}



// Guards:
export function isSCEvent(value: MessageEvent): value is MessageEvent<SessionCloseEvent> {
  return (value.data as SessionCloseEvent | undefined)?.eventName === 'session-close';
}

export function isSFEvent(value: MessageEvent): value is MessageEvent<SaveFailedEvent> {
  return (value.data as SaveFailedEvent | undefined)?.eventName === 'save-failed';
}

export function isSaveResult(value: MessageEvent): value is MessageEvent<SessionCloseEvent> | MessageEvent<SaveFailedEvent> {
  const data = value.data;
  if (!data) {
    return false;
  }
  return data.eventName === 'session-close' || data.eventName === 'save-failed';
}


export function isCodeSelectedEvent(value: MessageEvent): value is MessageEvent<CodeSelectedEvent> {
  return (value.data as CodeSelectedEvent | undefined)?.eventName === 'code-selected';
}

export function isNoCodeSelectedEvent(value: MessageEvent): value is MessageEvent<NoCodeSelectedEvent> {
  return (value.data as NoCodeSelectedEvent | undefined)?.eventName === 'no-code-selected';
}

export function isCodeSelectionChange(value: MessageEvent): value is MessageEvent<CodeSelectedEvent> | MessageEvent<NoCodeSelectedEvent> {
  const data = value.data;
  if (!data) {
    return false;
  }
  return data.eventName === 'code-selected' || data.eventName === 'no-code-selected';
}
